export default __webpack_public_path__ + "static/media/quagsire.9f5a005e.gif";